const GameStatus = {};

GameStatus.NONE = 0;
GameStatus.RUNNING = 1;
GameStatus.TIMEOUT = 2;
GameStatus.END = 3;

export default GameStatus;